import List from '../../shared/revenues-list'

export default {
  List,
}
